import React from "react";
import {Checkbox, Text} from "@renta-apps/renta-react-components";
import AlertSubscriptionManagement, {defaultComparer, IBaseAlertSubscriptionManagementProps} from "./AlertSubscriptionManagement";
import Localizer from "@/localization/Localizer";
import CustomSlider from "@/components/CustomSlider/CustomSlider";
import styles from "./AlertSubscriptionsManagement.module.scss";
import AlarmData from "@/models/server/AlarmData";

interface IFuelAlertSubscriptionManagementProps extends IBaseAlertSubscriptionManagementProps {
    value?: number | null;
    onAlertDataChange: (value: AlarmData) => void;
}

const DEFAULT_FUEL_VALUE = 20;

const FuelAlertSubscriptionManagement: React.FC<IFuelAlertSubscriptionManagementProps> = ({
    onChange,
    onAlertDataChange,
    onAdjustmentChange,
    value: fuelPercentage,
    isAdjustmentEnabled,
    ...props
}: IFuelAlertSubscriptionManagementProps) => {
    const handleChanged = (checked: boolean) => {
        onChange(checked);
        if (checked && (fuelPercentage ?? null) === null) {
            onAlertDataChange({value: DEFAULT_FUEL_VALUE, min: null, max: null});
        }
    };

    return (
        <AlertSubscriptionManagement id="fuelCheckbox"
                                     label={Localizer.fleetMonitoringPageSubscribeToAlertsModalFuelLow}
                                     adjustable
                                     isAdjustmentEnabled={isAdjustmentEnabled}
                                     thresholdText={Localizer.fleetMonitoringPageSubscribeToAlertsModalAdjustFuelThreshold}
                                     thresholdDescriptionText={Localizer.fleetMonitoringPageSubscribeToAlertsModalAdjustFuelThresholdDescription}
                                     onChange={handleChanged}
                                     onAdjustmentChange={onAdjustmentChange}
                                     {...props}
        >
            {props.checked && (
                <div className={styles.sliderContainer}>
                    <Text tag="label" size="Normal" weight="medium">{Localizer.fleetMonitoringPageSubscribeToAlertsModalFuelLowDescription}</Text>
                    <CustomSlider
                        min={10}
                        max={90}
                        step={5}
                        value={fuelPercentage ?? DEFAULT_FUEL_VALUE}
                        onChange={(value: number) => onAlertDataChange({value, min: null, max: null})}
                        disabled={props.disabled || (!isAdjustmentEnabled && !props.singleDevice)}
                        unit="%"
                    />
                </div>
            )}
        </AlertSubscriptionManagement>
    );
};

const comparer = (prevProps: IFuelAlertSubscriptionManagementProps, nextProps: IFuelAlertSubscriptionManagementProps) => {
    return defaultComparer(prevProps, nextProps) && prevProps.value === nextProps.value && prevProps.isAdjustmentEnabled === nextProps.isAdjustmentEnabled;
};

export default React.memo(FuelAlertSubscriptionManagement, comparer);